<template>
  <form
    @submit.prevent="onSave">
     <fixed-header id="sticky-header">
      <div class="row form-header py-2">
        <div class="col-sm-4 col-xl-4 m-auto">
          <a class="h6" href="javascript:void(0)"
            @click="onView"
          >
            <i class="uil-arrow-left"></i> {{$t('common.back_to').toUpperCase()}} {{$t('company.singular').toUpperCase()}} 
          </a>
        </div>
        <div class="col-sm-8 col-xl-8 text-sm-right">
          <div class="btn-group d-sm-inline-block">
              <button 
                type="submit" 
                class="btn2 btn2-primary btn-sm"
              ><i class="uil uil-edit mr-1"></i>Save</button>
          </div>
        </div>
        
      </div>
    </fixed-header>

    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
      {{errorMessage}}
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="avatar-upload" v-if="model._id">
                  <div class="avatar-edit">
                    <input 
                      type='file' 
                      id="imageUpload" 
                      @change="onAvatarChange"
                      accept=".png, .jpg, .jpeg" />
                    <label for="imageUpload"><i class="uil uil-pen"></i>  </label>
                  </div>
                  <div class="avatar-preview">
                    <img
                      ref="imagePreview"
                      :src="model.avatar_path"
                      alt
                      class="avatar-md rounded-rounded"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <TextField 
                  :placeholder="$t('company.form.name.placeholder')"
                  :label="$t('company.form.name.label')"
                  v-model="model.name"
                  :error="$v.model.name.$error"
                  :errorMessage="$v.model.name.errorMessage"
                />
                <TextField 
                  :placeholder="$t('company.form.website.placeholder')"
                  :label="$t('company.form.website.label')"
                  v-model="model.website"
                />
                <TextField 
                  :placeholder="$t('company.form.contact_no.placeholder')"
                  :label="$t('company.form.contact_no.label')"
                  v-model="model.contact_no"
                  :error="$v.model.contact_no.$error"
                  :errorMessage="$v.model.contact_no.errorMessage"
                />
                <TextField 
                  :placeholder="$t('company.form.email.placeholder')"
                  :label="$t('company.form.email.label')"
                  v-model="model.email"
                  :error="$v.model.email.$error"
                  :errorMessage="$v.model.email.errorMessage"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{$t('company.form.information')}}</h4>
            <p class="sub-header"></p>
            <div class="row">
              <div class="col-md-6">
                <DropDown 
                  placeholder="Select a Timezone"
                  label="Timezone"
                  v-model="model.timezone"
                  :name.sync="model.timezone"
                  :options="timezone_option" 
                  :error="$v.model.timezone.$error"
                  :errorMessage="$v.model.timezone.errorMessage"
                />
              </div>
              <div class=" col-md-6">
                <div class="form-group">
                  <label for="" class="form-label">{{ $t('user.form.industry.label') }}</label>
                  <multiselect
                    v-model="model.industry_id"
                    :options="industry_options"
                    :searchable="true"
                    :multiple="true"
                    :placeholder="$t('user.form.industry.placeholder')"
                    :clear-on-select="false"
                    :close-on-select="false"
                    :show-labels="false"

                    track-by="_id"
                    label="name"
                  ></multiselect>
                </div>
              </div>
              <div class=" col-md-6">
                <div class="form-group">
                  <label for="" class="form-label">Source Companies</label>
                  <multiselect
                    v-model="model.source_company"
                    :options="source_company_options"
                    :searchable="true"
                    :multiple="true"
                    placeholder="Enter Source Company"
                    :clear-on-select="false"
                    :close-on-select="false"
                    :show-labels="false"
                    track-by="_id"
                    label="name"
                  ></multiselect>
                </div>
              </div>
              <div class=" col-md-6">
                <div class="form-group">
                  <DropDown 
                    placeholder="Select Brand"
                    label="Brands"
                    v-model="model.brand_id"
                    :options="brand_options"
                    value="_id"
                    name="name"
                    @change="selectedBrand"
                  />
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-6">
                <TextField 
                  :placeholder="$t('company.form.city.placeholder')"
                  :label="$t('company.form.city.label')"
                  v-model="model.city"
                  :error="$v.model.city.$error"
                  :errorMessage="$v.model.city.errorMessage"
                />
              </div>
              <div class="col-md-6">
                <TextField 
                  :placeholder="$t('company.form.country.placeholder')"
                  :label="$t('company.form.country.label')"
                  v-model="model.country"
                  :error="$v.model.country.$error"
                  :errorMessage="$v.model.country.errorMessage"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <vue-editor height="300"
                  :placeholder="$t('company.form.remarks.placeholder')"
                  v-model="model.remarks">
                </vue-editor>
              </div>
            </div>
            <hr>
            <div class="row mt-2">
              <div class="col-md-12">
                <h4 class="header-title mt-0 mb-3">{{$t('company.form.commission_setup')}}</h4>
                <div class="form-group">
                  <b-form-checkbox 
                    v-model="model.fixed" 
                    name="check-button" 
                    switch
                    @change="onBlur"
                    >
                    {{$t('company.form.use_fixed_rate')}}
                  </b-form-checkbox>
                </div>
                <div class="row">
                  <TextField 
                    :max="model.fixed ? 0 : 100"
                    :placeholder="model.fixed ? 'xx,xxx' : '%'"
                    :label="$t('company.form.commission_rate.label')"
                    type="number"
                    class="col-md-6"
                    v-model="model.rate"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </form>
</template>

<script>
import FixedHeader from 'vue-fixed-header'
import TextField from '@components/form/textfield.vue'
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
import { VueEditor } from 'vue2-editor'
import DropDown from '@components/form/dropdown.vue'
import timezone from '@src/data/timezone.json'
import Multiselect from 'vue-multiselect'

export default {
  mixins: [FormMixin],
  components:{FixedHeader, TextField, VueEditor, DropDown, Multiselect},
  data(){
    return {
      model:{
        name: '',
        remarks: '',
        fixed:false,
        website: '',
        contact_no: '',
        email: '',
        avatar_path: '',
        city: '',
        country: '',
        rate:0,
        timezone:'',
        brand_id: ''
      },
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth,
      timezone_option:timezone,
      industry_options:[],
      function_options:[],
      source_company_options:[],
      brand_options: []
    }
  },
  validations: {
    model:{
      name: { required },
      email: { required },
      timezone: { required },
      contact_no: { required },
      city: { required },
      country: { required }
    }
  },
  created(){
    this.renderAvatar()
  },
  mounted(){
    window.addEventListener('resize', this.handleResize)
  },
  updated(){
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('company', ['create', 'update', 'find', 'uploadAvatar']),
    onView() {
      if(this.$route.query.id){
        this.$router.push('/company/view?id=' + this.$route.query.id)
      }else{
        this.$router.push('/company')
      }
    },
    onBlur(){
      if(parseInt(this.model.rate) > 100){
        this.model.rate = 100
      }
    },
    async renderAvatar(){
      let id = this.$route.query.id
      if(id){
        this.find({
          id:id
        }).then(data => {
          this.model = data.data
          this.model.id = data.data._id
          this.model.rate = data.data.rate.$numberDecimal
          this.model.avatar_path = this.model.avatar_path != '' ? this.model.avatar_path : require('@assets/images/users/avatar-7.jpg')
          // this.$refs.imagePreview.src = this.model.avatar_path
        })
      }

      await this.$store.dispatch('industry/all').then(data => {
        data.data.forEach(el => {
          this.industry_options.push(el) 
        })
      })

      await this.$store.dispatch('industry/getSourceCompany').then(data => {
        data.data.forEach(el => {
          this.source_company_options.push(el) 
        })
      })

      await this.$store.dispatch('function/all').then(data => {
        data.data.forEach(el => {
          this.function_options.push(el) 
        })
      })

      await this.$store.dispatch('function/all').then(data => {
        data.data.forEach(el => {
          this.function_options.push(el) 
        })
      })

      await this.$store.dispatch('brand/all').then(data => {
        data.data.forEach(el => {
          this.brand_options.push({ value: el._id, text: el.name })
        })
      })
    },
    selectedBrand(val){
      this.model.brand_id = val
    },
    onAvatarChange(e) {
      let input = e.target

      if (input.files && input.files[0]) {
        this.toggleLoading()
        
        var formData = new FormData();

        formData.append("avatar", input.files[0]);
        formData.append("id", this.$route.query.id);

        this.uploadAvatar(formData).then(res => {

          if(res.data.success == true){
            var reader = new FileReader();

            reader.onload = (a) => {
              this.$refs['imagePreview'].src = a.target.result
              this.toggleLoading()
            }

            reader.readAsDataURL(input.files[0]);
          }else{
            this.toggleLoading()
          }
          
        })
      }

    },
    onSave() {

      if (this.validateForm()) {
				this.toggleLoading()
				return;
			}
      
      this[!this.model.id ? 'create' : 'update'](this.model)
      .then(()=> {
        this.toggleLoading()
        if(this.$route.query.id){
          this.$router.push('/company/view?id=' + this.$route.query.id)
        }else{
          this.$router.push('/company')
        }
      })
      .catch((err) => {
        this.toggleLoading()

        Object.keys(err.response.data).forEach(key => {
          if(this.$v.model[key]) this.$v.model[key].errorMessage = err.response.data[key]
        })

        this.setError(err.response.data.msg)

      })
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    onCancel() {
      this.$router.push('/company')
    }
  }
}
</script>

